import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

let store =  new Vuex.Store({
  plugins: [createPersistedState({key: 'tatkalorri'})],
  state: {
    userObj: '',
    accessibleUrls: [],
    mappedAreas: {},
    mappedUsers: {},
  },
  mutations: {
    setUserObj(state, payload){
        state.userObj = payload
    },
    setAccessibleUrls(state, payload){
        state.accessibleUrls = payload
    },
    setMappedAreas(state, payload){
        state.mappedAreas = payload
    },
    setMappedUsers(state, payload){
        state.mappedUsers = payload
    }
  },
  actions: {

  }
})
export default store
